import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { CASH_DESK_ACTION_TYPE } from "./cash-desk.action";
import { CashDeskState } from "./cash-desk.model";

const INITIAL_STATE: CashDeskState = {
	isBusy: false,
	cashDesks: {},
};

export function cashDeskReducer(state = INITIAL_STATE, action: ActionWithPayload): CashDeskState {
	switch (action.type) {
		case CASH_DESK_ACTION_TYPE.get: {
			return updateState(state, {
				isBusy: true,
			});
		}
		case CASH_DESK_ACTION_TYPE.getSuccess: {
			return updateState(state, {
				isBusy: false,
				cashDesks: action.payload,
			});
		}
		case CASH_DESK_ACTION_TYPE.getFail: {
			return updateState(state, {
				isBusy: false,
			});
		}
		default:
			return state;
	}
}
